function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import Input from "./Input";
import InputErrorMessage from "./InputErrorMessage";

const InputFormField = ({
  meta: {
    error,
    active,
    touched
  },
  input,
  ...rest
}) => {
  const withError = touched && !!error && !active;
  return (
    /*#__PURE__*/

    /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
     * v0.112.0. To view the error, delete this comment and run Flow. */
    React.createElement(Input, _extends({}, input, {
      withError: withError
    }, rest), withError && /*#__PURE__*/React.createElement(InputErrorMessage, {
      message: error
    }))
  );
};

export default InputFormField;